export default __webpack_public_path__ + "static/media/57_mobile.2e5be23d.jpg";